module.exports = __webpack_public_path__ + "img/hand-draw-map-xiangshan-2.813b286c.png";